import { useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import useDashboardStore from "store/dashboard-store";
import useScadaStore from "store/scada-store";
import useSelectedScadaTagsStore from "store/selected-scada-tags-store";

const useScadaTagMove = (
	ref: React.RefObject<HTMLElement | null>,
	x: number,
	y: number,
	gridSize: number,
	identifier: string,
	scadaId: string,
) => {
	const [tagPosition, setTagPosition] = useState({ x, y });
	const scadaStore = useScadaStore();
	const selectedTags = useSelectedScadaTagsStore(state => state.tags);
	const isEditMode = useDashboardStore(state => state.isEditMode);
	const isSelectedInEditMode = selectedTags.includes(ref.current!) && isEditMode;
	const scadaArgs: [string, string] = [scadaId, identifier]
	
	useHotkeys('ctrl+up', () => {
		if (isSelectedInEditMode && newPosition('y', 'sub') >= 0) {
			setTagPosition(prev => ({ ...prev, y: prev.y - gridSize }));
			scadaStore.updateScadaLabelXY( ...scadaArgs, tagPosition.x, newPosition('y', 'sub'));
		}
	});

	useHotkeys('ctrl+down', () => {
		if (isSelectedInEditMode && newPosition('y', 'add') <= 97) {
			setTagPosition(prev => ({ ...prev, y: prev.y + gridSize }));
			scadaStore.updateScadaLabelXY( ...scadaArgs, tagPosition.x, newPosition('y', 'add'));
		}
	});

	useHotkeys('ctrl+left', () => {
		if (isSelectedInEditMode && newPosition('x', 'sub') >= 0) {
			setTagPosition(prev => ({ ...prev, x: prev.x - gridSize }));
			scadaStore.updateScadaLabelXY( ...scadaArgs, newPosition('x', 'sub'), tagPosition.y);
		}
	});

	useHotkeys('ctrl+right', () => {
		if (isSelectedInEditMode && newPosition('x', 'add') <= 97) {
			setTagPosition(prev => ({ ...prev, x: prev.x + gridSize }));
			scadaStore.updateScadaLabelXY( ...scadaArgs, newPosition('x', 'add'), tagPosition.y);
		}
	});

	const newPosition = (axis: 'x' | 'y', operation: 'add' | 'sub') => {
		if (operation === 'add') return tagPosition[axis] + gridSize;
		return tagPosition[axis] - gridSize;
	}

	return tagPosition;
};

export default useScadaTagMove;